import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { store } from '../../core/state/store';
import {
  AddToast,
  SetBounced,
  SetRestaurantUrl,
} from '../../weborder/actions/Actions';
import { routerActions } from '../../weborder/redux';
import * as Store from '../../weborder/Store';
import { SetCookie as SetCookiePage } from './SetCookie';

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;
export type StateProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: Store.State) => ({
  appConfig: state.flipdish.AppConfig,
  appDesignScheme: state.appDesignScheme,
  bounced: state.flipdish.Bounced,
  collectionSummaries: state.flipdish.CollectionSummaries,
  customer: state.flipdish.Customer,
  deliverySummaries: state.flipdish.DeliverySummaries,
  deviceId: state.flipdish.Config.DeviceId,
  isClientAnalyticsLoaded: state.flipdish.ClientAnalytics,
  isDark: state.flipdish.isDark,
  showRestaurantList: state.flipdish.Config.showRestaurantList,
  translate: getTranslate(state.locale),
});

const mapDispatchToProps = (dispatch: any) => ({
  addToast: (message: string) => {
    dispatch(AddToast(message));
  },
  loadCollectionSummaries: () => {
    dispatch(store.middleware.loadCollectionSummaries());
  },
  loadDeliverySummaries: () => {
    dispatch(store.middleware.loadDeliverySummaries());
  },
  setBounced: (bounced: boolean) => {
    dispatch(SetBounced(bounced));
  },
  setRestaurantUrl: (url: string) => {
    dispatch(SetRestaurantUrl(url));
  },
  updateRouterState: (payload: WebOrder.State.Location) => {
    dispatch(routerActions.updateRouterState(payload));
  },
});

export const SetCookie = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SetCookiePage);
